import { Component, OnInit } from '@angular/core';
import { ApplicationStateStoreProxyService } from '@ddt-web/shared-stores';
import { UrlService } from '@ddt-web/url';
import { combineLatest, Observable, of } from 'rxjs';
import { first, switchMap } from 'rxjs/operators';

import { ModelsBrowseDataService } from '../services/models-browse-data.service';

@Component({
	selector: 'mb-family-performance-commentary',
	templateUrl: './family-performance-commentary.component.html'
})
export class FamilyPerformanceCommentaryComponent implements OnInit {
	public familyIds: Observable<Array<string>>;
	public canShowPerformanceCommentary$: Observable<boolean>;
	constructor(
		private urlService: UrlService,
		private modelsBrowseDataService: ModelsBrowseDataService,
		private applicationStateStoreProxyService: ApplicationStateStoreProxyService
	) { }

	public ngOnInit(): void {
		const familyId = this.urlService.getModelFamilyId();
		this.familyIds = of([familyId]);
		this.checkPerformanceDataValidity(familyId);
	}

	private checkPerformanceDataValidity(familyId: string): void {
		this.canShowPerformanceCommentary$ = combineLatest([
			this.modelsBrowseDataService.fetchFamilyModelsAnalytics(familyId),
			this.applicationStateStoreProxyService.getPerformanceState()
		]).pipe(
			switchMap(
				([familyId, performanceState]) => this.modelsBrowseDataService.checkPerformanceDataValidity(familyId, performanceState?.customAdvisoryFee)
			),
			first()
		);
	}
}
